<template>
    <div id="ticket-component">
        <div class="row">
            <form id="formTicketQuoter" class="animated fadeIn formTicketQuoter">
                <input type="hidden" name="quoter_id" :value="quoter_id">
                <input type="hidden" name="commission" :value="commission">
                <div class="col-12 col-sm-12">
                    <input type="text" name="price" class="al-inputs required scr-input" placeholder="Costo" id="price">
                </div>
                <div class="col-12 col-sm-12">
                    <div class="fotoUploader">
                        <span class="btn btn-file">
                            Documento <br> <i class="fas fa-upload"></i> <input type="file" class="required" accept="image/*,.pdf" data-label="avatar" name="ticket_file" v-on:change="getLogo" placeholder="Documento">
                        </span>
                        <span class="label-file-papeleria alert alert-info logo"></span>
                    </div>
                </div>
                <div class="col-12 col-sm-12">
                    <p class="fotoUploader">
                        <strong>Formatos permitidos: .jpeg, .png, .jpg, .gif, .pdf, con un peso máximo de 500kb</strong>
                    </p>
                </div>
                <div class="col-12 col-sm-12">
                    <button id="dyn-button" type="button" class="btn btn-primary addNote" v-on:click="guardar()">{{ tituloBtn }}</button>
                </div>
            </form>

            <div class="col-12 col-sm-12">
                <h2 class="cabeza">Factura de la comisión</h2>
                <b-table responsive id="my-table" striped hover :fields="fields" :busy="isBusy" :items="tickets" show-empty>
                    <template #empty="scope">
                        <h4 class="emptyRow">
                            No hay datos para mostrar.
                        </h4>
                    </template>
                    <template #cell(factura_name)="{item}">
                        <a class="fileName float" v-if="item.factura_name" :href="'../storage/quotings/facturas/'+item.factura_name+'.pdf'" target="_blank">
                            {{ item.factura_name }}
                        </a>
                    </template>
                    <template #cell(concepto)="{item}">
                        <span>{{ item.concepto }}</span>
                    </template>
                    <template #cell(fecha_de_carga)="{item}">
                        <span>{{ item.created_at }}</span>
                    </template>
                    <template #cell(usuario)="{item}">
                        <span v-if="item.agent_id!=null" class="badge rounded-pill text-bg-success">Agente</span>
                        <span v-if="item.promoter_id!=null" class="badge rounded-pill text-bg-success">Promotor</span>
                    </template>
                    <template #cell(total)="{item}">
                        <span>{{ item.total }}</span>
                    </template>
                    <template #cell(accion)="{item}">
                        <div class="dropdown">
                            <button class="btn btn-warning dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                <i class="fas fa-cogs"></i>
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="javascript:void(0)" v-on:click="onClickDelete(item.id)">Borrar</a>
                            </div>
                        </div>
                    </template>
                    <template #table-busy>
                        <div class="text-center text-danger my-2">
                            <b-spinner class="align-middle"></b-spinner>
                            <strong>Cargando...</strong>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
    </div>
</template>
<script>
import {myMixins} from "../mixins/myMixins";
import {ticketQuoterService} from "../../Services/TicketQuoter.service";
import {getFormData} from "../../Utils/getDataForm";
import {invoiceQuotersService} from "../../Services/InvoiceQuoters.service";

export default {
    name: 'ticket',
    mixins: [myMixins],
    props: {
        quoter_id: {
            type: Number,
            required: true
        },
        approved_at: {
            type: Boolean,
            required: false
        },
        commission: {
            type: Number,
            required: false,
            default: null
        },
    },
    data() {
        return {
            isBusy: false,
            modificar: false,
            type_ticket: 0,
            fields: [
                {key: 'factura_name', label: 'Factura'},
                {key: 'concepto', label: 'Concepto'},
                {key: 'fecha_de_carga', label: 'Fecha de carga'},
                {key: 'total', label: 'Total'},
                {key: 'usuario', label: 'usuario'},
                {key: 'accion', label: 'Acción'}
            ],
            tickets: [],
            tituloBtn: 'Agregar Documento',
        }
    },
    methods: {
        async onClickDelete(id) {
            let resp = await invoiceQuotersService.deleteOne(id);
            this.getAlert(resp.process);
            await this.index();
        },
        async guardar() {
            let resp = '';
            let respVal = this.valFormulariosV3('formTicketQuoter');
            if (respVal) {
                this.disableSubmitBtn(true);
                const formData = getFormData('formTicketQuoter');
                resp = await ticketQuoterService.saveOne(formData, {isForm: true, onUploadProgress: this.onUploadProgress});
                //this.ticket.archivo = '';
                this.getAlert(resp.process);
                //this.$emit('close-modal');
                this.disableSubmitBtn(false);
                await this.index();
            }
            this.modificar = false;
        },
        async index() {

            let resp = '';
            //console.log('quoter_id', this.quoter_id, 'approved_at', this.approved_at);
            this.isBusy = true;
            //this.tickets = await ticketQuoterService.getOne(this.quoter_id);

            //NECESITO CHECAR QUE EL ADMIN PUEDA VER LAS FACTURAS QUE SE SUBIERON PARA EL PAGO DE COMISIONES
            resp = await invoiceQuotersService.getOne(this.quoter_id);

            this.tickets = [
                {'id': resp.id, 'factura_name': resp.factura_name, 'concepto': resp.concepto, 'created_at': this.formatDate(resp.created_at), 'agent_id': resp.agent_id, 'promoter_id': resp.promoter_id, 'total': resp.total}
            ];

            //console.log('tickets = ', this.tickets);
            this.isBusy = false;
        },
        getLogo(event) {
            this.getNameFile(event, 'logo');
        },
    },
    mounted() {
        this.index();
    }
}
</script>
